import axios from "axios";

export class PdfHelper {
    formatDate(originalDate: string) {


        if (originalDate.indexOf('-') === -1) {
            return originalDate;
        }

        // Convert the string to a Date object
        const date = new Date(originalDate);

        // Format the date to "Day dd/mm/yyyy"
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            weekday: 'short',  // "Thur"
            day: '2-digit',    // "31"
            month: '2-digit',  // "10"
            year: 'numeric'    // "2024"
        }).format(date);
        return formattedDate;

    }


    async resolveLogoByBrand(brand: string) {
      
            let arr = {
                'FFD':  'factoryflooring.png',
                'DEL':  'delta.png', 
                'DELTA':  'delta.png', 
                'AA': 'aa.png',
                'AAANDA': 'aa.png',
                'AANDA': 'aa.png',
                'BAS' : 'south.png',
                'BASD' : 'south.png',
                'BIRD' : 'midlands.png',
                'BIRP' : 'midlands.png',
                'DAV' : 'likewise_floors.png',
                'DEW' : 'likewisenorth.jpg',
                'DEWT' : 'likewisenorth.jpg', 
                'FFS': 'factoryflooring.png', 
                'GLA': 'sc.png', 
                'HO': 'lwl.png', 
                'HV': 'hv.png', 
                'HAV': 'hv.png', 
                'HAV4': 'hv.png', 
                'HVBUK': 'hv.png', 
                'HVDAV': 'hv.png', 
                'HVHO': 'hv.png', 
                'HVNEW': 'hv.png', 
                    'HAVB': 'hv.png', 
                'HVSCO': 'hv.png',
                'LAD': 'Lewis-new.jpg', 
                'LADSUD' : 'Lewis-new.jpg', 
                'LNE': 'ne.png', 
                'LSC': 'sc.png', 
                'LWL': 'lwl.png',
                'LWMID': 'midlands.png',
                'LWM': 'midlands.png',
                'LWS': 'south.png',
                
                'LEWSOUTH': 'south.png',
                'LWSW': 'sw.png',
                'ZLWSW': 'sw.png',
                'LWSE' : 'se.png',
                'LSE' : 'se.png',
                'LWW': 'wales.png',
                'MOR' : 'likewise_floors.png',
                'MORD': 'likewise_floors.png',
                'MORP': 'likewise_floors.png',
                'LIKFLOOR': 'likewise_floors.png',
                          
               'SCOD': 'sc.png',
                'SUD': 'se.png',
                'SUDD': 'se.png',
                'SUDMAT': 'mattingg.png',
                'PAYSMART': 'paysmart.png', 
                'LAZYCARPETS': 'lazycarpets.png', 
                'LAFLOOR' : 'Lewis-new.jpg'
            }as any;

        let i = arr[brand];

        console.log( `/logos/${i}`);


        // Fetch image from dataset
        const response = await fetch(`/logos/${i}`);
        const blob = await response.blob();
        const base64String = await this.convertBlobToBase64(blob);
        return base64String;
    }
    /*
    async resolveLogoByBrand(brand: any) {

        let img = new Image();
        img.src = brand;

        brand = brand.split('/');
        let url = brand[brand.length - 1];

        const response = await fetch(`/logos/${url}`);
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);

        const base64String = await this.convertBlobToBase64(blob);
        return base64String;
    }
        */

    convertBlobToBase64(blob: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    getPrimaryColour(company: string) {


        let lw = ['LW', 'LWN', 'FFD', 'LSC', 'LWMID', 'LEWSOUTH', 'LWS', 'LWMATNEW', 'SUDMAT', 'LEWSOUTH', 'BAS', 'LSE', 'SUD', 'LEWLONDN', 'HO'];

        if (lw.indexOf(company) > -1) {
            return '#e26329';
        }


        if (company == 'DELTA') {
            return '#c40d3c';
        }
        if (company == 'HAV' || company == 'HVHO' || company == 'HVSCO') {
            return '#747474';
        }

        return '#747474';

    }

    getSecondaryColour(company: string) {

        let lw = ['LW', 'LWN', 'FFD', 'LSC', 'LWMID', 'LEWSOUTH', 'LWS', 'LWMATNEW', 'SUDMAT', 'LEWSOUTH', 'BAS', 'LSE', 'SUD', 'LEWLONDN', 'HO'];

        if (lw.indexOf(company) > -1) {
            return '#333333';
        }

        if (company == 'DELTA') {
            return '#060f41';
        }

        if (company == 'HAV' || company == 'HVHO' || company == 'HVSCO') {
            return '#434975';
        }

        return '#2B2B2B';
    }


    toTitleCase(str: any) {
        return str.replace(
            /\w\S*/g,
            function (txt: any) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }


    getDate() {
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // January is 0!
        const year = currentDate.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    }

    getTableLayouts() {
        return {};
    }

    rightTrim(str: any, charToRemove: any) {
        const escapedChar = charToRemove.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special regex chars
        const regex = new RegExp(escapedChar + '+$'); // Match the specific character at the end
        return str.replace(regex, '');
    }
}